<template>
  <div class="adminaside">
    <router-link to="/user" class="alogo"></router-link>
    <el-aside width="258px">
      <el-menu default-active="0" class="eldemo" @open="handleOpen" @close="handleClose" :router="true">
        <el-menu-item index="/user">
          <i class="sideicon user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <i class="sideicon list"></i>
            <span slot="title">店铺管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/shop"><span>店铺信息</span></el-menu-item>
            <el-menu-item index="/gift"><span>礼品信息</span></el-menu-item>
            <el-menu-item index="/acti"><span>活动信息</span></el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
  </div>
</template>

<script>
import * as api from '@/api'
export default {
  name: 'adminaside',
  data() {
    return {
      user: JSON.parse(localStorage.getItem('setUserInfo')) || {},
      permissionList: [],
      level: false,
    }
  },
  mounted() {
    this.getDetail(this.user.id)
  },
  computed: {
    _p() {
      return (id) => {
        return this.permissionList.includes(id) || this.level == true
      }
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    p(id) {
      return this.permissionList.includes(id) || this.level == true
    },
    async getDetail(id) {
      api.getAccountDetail({
        admin_id: id,
      })
        .then((res) => {
          const resD = res.resData
          return resD
        })
    },
  },
}
</script>

<style lang="scss">
.sideicon {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-size: contain;
  margin-right: 10px;

  &.home {
    background-image: url(../assets/images/home.png);
  }

  &.biao {
    background-image: url(../assets/images/biao.png);
  }

  &.list {
    background-image: url(../assets/images/list.png);
  }

  &.more {
    background-image: url(../assets/images/more.png);
  }

  &.say {
    background-image: url(../assets/images/say.png);
  }

  &.user {
    background-image: url(../assets/images/user.png);
  }
}

.el-aside::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.adminaside {
  min-height: 100vh;
  position: relative;

  .alogo {
    width: px(177.2);
    height: px(23.3);
    display: block;
    margin: 30px auto 20px;
    background: url(../assets/alogo.png) no-repeat;
    background-size: contain;
  }

  .el-submenu__title {
    border-bottom: 1px solid rgba($c, 1);
    font-size: 16px;
  }

  .el-menu {
    border-right: none;

    .el-menu-item-group__title {
      padding: 0;
    }

    .el-menu-item {
      background: $c;
      color: #fff;
      font-size: 16px;
      border-bottom: 1px solid rgba($c, 1);
    }
  }

  .el-submenu.is-opened {
    .el-submenu__title {
      background: $c;
      color: #fff;
      border-bottom: 1px solid #fff;

      i {
        color: #fff;
      }
    }

    .el-menu .el-menu-item {
      background: $c;
      color: #fff;
      border-bottom: 1px solid rgba(#fff, 0.5);

      span {
        font-size: 14px;
      }

      &.is-active {
        span {
          border-bottom: 1px solid #fff;
        }
      }
    }
  }

  .el-submenu__title,
  .el-submenu__title:hover {
    background: $c;
    color: #fff;

    i {
      color: #fff;
    }

    border-bottom-color: #fff;
  }
}
</style>
